module.exports = __webpack_public_path__ + "static/media/pm-img-login.abe6ef8a.svg";